import { File, GalleryVerticalEnd, X } from 'lucide-react';

import { Button } from '@/components/ui/button';

import { useDocumentsTableStore } from '@/store/documents-table.store';

type DocumentEmptyStateProps = {
  hasActiveFilters: boolean;
};

export function DocumentEmptyState({ hasActiveFilters }: DocumentEmptyStateProps) {
  const clearFilters = useDocumentsTableStore(state => state.clearFilters);

  return (
    <div className="flex flex-col items-center justify-center gap-3 py-4 text-muted-foreground">
      {hasActiveFilters ? (
        <>
          <GalleryVerticalEnd className="h-12 w-12 text-muted-foreground/40" />
          <div className="space-y-1">
            <p className="text-sm font-medium">No documents found</p>
            <p className="text-xs">Try adjusting your search or filters</p>
          </div>
          <Button variant="outline" size="sm" onClick={clearFilters}>
            <X className="h-4 w-4 mr-1" />
            Clear filters
          </Button>
        </>
      ) : (
        <>
          <File className="h-10 w-10 text-muted-foreground/40" />
          <div className="space-y-1">
            <p className="text-sm font-medium">No documents yet</p>
            <p className="text-xs">Upload your first document to get started</p>
          </div>
        </>
      )}
    </div>
  );
}
